<rask-checkbox
    class="cell"
    [(ngModel)]="value"
    [disabled]="readonly"></rask-checkbox>